import './AppliedFiltersPanel.scss';

import { Chip } from '@trackman/web-shared-components';
import { ReactComponent as CloseIcon } from 'images/icons/Close.svg';
import { TrackmanEventFilter } from 'types/trackmanEvents';
import { useTranslation } from 'react-i18next';

type Props = {
  filters: TrackmanEventFilter[];
  onFilterClick: (filters: TrackmanEventFilter) => void;
  clearAllFilters: () => void;
};

export const AppliedFiltersPanel = ({ filters, onFilterClick, clearAllFilters }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <div className='applied-filters'>
        {filters.map((filter, index) => {
          return (
            <Chip key={`${filter}-${index}`} clickable label={filter.label} icon={<CloseIcon />} onClick={() => onFilterClick(filter)} />
          );
        })}
      </div>
      <Chip className='clear-all-filters' clickable label={t('ClearAll', { ns: 'trackmanEvents' })} onClick={clearAllFilters} />
    </>
  );
};
